import { render, staticRenderFns } from "./Apresentacao.vue?vue&type=template&id=0646a351&style=true&"
import script from "./Apresentacao.vue?vue&type=script&lang=js&"
export * from "./Apresentacao.vue?vue&type=script&lang=js&"
import style0 from "./Apresentacao.vue?vue&type=style&index=0&id=0646a351&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports